import { request } from './request'
// 获取计划任务列表
export interface GetPlanTaskList {
  limit: number
  page: number
  // search?: string
  keyword?: string
  // task_type?: number
  scheduler_type?: number
  // create_time_end?: string
  start_time?: string
  // create_time_start?: string
  end_time?: string
  // area_id?: string
  biz_area?: string
}
export const getPlanTaskList = (data: GetPlanTaskList) =>
  request('/portal/verify/waf/job/jobList', {
    params: {
      ...data,
    },
  })
export const startPlanTask = data =>
  request('/portal/verify/waf/task/start', {
    method: 'post',
    data,
  })

export const pausePlanTask = data =>
  request('/portal/verify/waf/task/pause', {
    method: 'post',
    data,
  })

// 删除计划任务列表
export interface DeleteTask {
  task_id: string[]
}
export const deleteTask = (data: DeleteTask) =>
  request('/portal/verify/waf/task', {
    method: 'delete',
    data,
  })

//  获取计划详情
export interface Template {
  template_ids: string[]
}
export const template = (data: Template) =>
  request('/portal/verify/waf/task/template', {
    method: 'POST',
    data,
  })

export const getPlanDetail = (data: Template) =>
  request('/portal/verify/waf/job/jobDetail', {
    params: {
      ...data,
    },
  })
